(() => {
  const swm26ReviewRoots = document.querySelectorAll('[data-reviews]');
  if (!swm26ReviewRoots.length) return;

  const swm26ReviewClamp = (value, min, max) => Math.max(min, Math.min(max, value));

  const swm26ReviewDebounce = (fn, delay) => {
    let timeoutId;
    return (...args) => {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => fn(...args), delay);
    };
  };

  const swm26ReviewGetVisibleCount = (root) => {
    const slides = root.querySelectorAll('.swm26-reviews__card').length;
    if (window.innerWidth <= 989) return 1;
    return Math.min(6, slides);
  };

  swm26ReviewRoots.forEach((root) => {
    const swm26ReviewViewport = root.querySelector('[data-reviews-viewport]');
    const swm26ReviewTrack = root.querySelector('[data-reviews-track]');
    const swm26ReviewSlides = Array.from(root.querySelectorAll('.swm26-reviews__card'));
    const swm26ReviewPrevBtn = root.querySelector('[data-reviews-prev]');
    const swm26ReviewNextBtn = root.querySelector('[data-reviews-next]');

    if (!swm26ReviewViewport || !swm26ReviewTrack || !swm26ReviewSlides.length) return;

    let swm26ReviewIndex = 0;

    const swm26ReviewGetStep = () => {
      const firstSlide = swm26ReviewSlides[0];
      if (!firstSlide) return 0;

      const slideWidth = firstSlide.offsetWidth;
      const trackStyles = window.getComputedStyle(swm26ReviewTrack);
      const gap = parseFloat(trackStyles.columnGap || trackStyles.gap || '0');

      return Math.round(slideWidth + gap);
    };

    const swm26ReviewGetMaxIndex = () => {
      return Math.max(0, swm26ReviewSlides.length - swm26ReviewGetVisibleCount(root));
    };

    const swm26ReviewUpdateVisibility = () => {
      if (window.innerWidth <= 989) {
        swm26ReviewSlides.forEach((slide) => {
          slide.classList.add('is-visible');
          slide.classList.remove('is-leaving-left', 'is-leaving-right');
        });
        return;
      }

      const visibleCount = swm26ReviewGetVisibleCount(root);
      const start = swm26ReviewIndex;
      const end = swm26ReviewIndex + visibleCount - 1;

      swm26ReviewSlides.forEach((slide, i) => {
        if (i >= start && i <= end) {
          slide.classList.add('is-visible');
          slide.classList.remove('is-leaving-left', 'is-leaving-right');
        } else {
          if (slide.classList.contains('is-visible')) {
            slide.classList.remove('is-visible');

            if (i < start) {
              slide.classList.add('is-leaving-left');
              slide.classList.remove('is-leaving-right');
            } else {
              slide.classList.add('is-leaving-right');
              slide.classList.remove('is-leaving-left');
            }
          }
        }
      });
    };

    const swm26ReviewUpdate = () => {
      if (window.innerWidth <= 989) {
        swm26ReviewTrack.style.transform = 'translate3d(0, 0, 0)';
        if (swm26ReviewPrevBtn) swm26ReviewPrevBtn.disabled = true;
        if (swm26ReviewNextBtn) swm26ReviewNextBtn.disabled = true;
        swm26ReviewUpdateVisibility();
        return;
      }

      const maxIndex = swm26ReviewGetMaxIndex();
      swm26ReviewIndex = swm26ReviewClamp(swm26ReviewIndex, 0, maxIndex);

      const step = swm26ReviewGetStep();
      const offset = step * swm26ReviewIndex;

      swm26ReviewTrack.style.transform = `translate3d(${-offset}px, 0, 0)`;

      if (swm26ReviewPrevBtn) swm26ReviewPrevBtn.disabled = swm26ReviewIndex <= 0;
      if (swm26ReviewNextBtn) swm26ReviewNextBtn.disabled = swm26ReviewIndex >= maxIndex;

      swm26ReviewUpdateVisibility();
    };

    swm26ReviewPrevBtn?.addEventListener('click', () => {
      swm26ReviewIndex -= 1;
      swm26ReviewUpdate();
    });

    swm26ReviewNextBtn?.addEventListener('click', () => {
      swm26ReviewIndex += 1;
      swm26ReviewUpdate();
    });

    root.addEventListener('keydown', (event) => {
      if (window.innerWidth <= 989) return;

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        swm26ReviewIndex -= 1;
        swm26ReviewUpdate();
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        swm26ReviewIndex += 1;
        swm26ReviewUpdate();
      }
    });

    root.tabIndex = 0;

    const swm26ReviewOnResize = swm26ReviewDebounce(() => {
      swm26ReviewUpdate();
    }, 120);

    window.addEventListener('resize', swm26ReviewOnResize);
    window.addEventListener('load', swm26ReviewUpdate, { once: true });

    const swm26ReviewImages = root.querySelectorAll('img');
    let swm26ReviewPendingImages = 0;

    swm26ReviewImages.forEach((img) => {
      if (img.complete) return;

      swm26ReviewPendingImages += 1;

      img.addEventListener(
        'load',
        () => {
          swm26ReviewPendingImages -= 1;
          if (swm26ReviewPendingImages <= 0) {
            swm26ReviewUpdate();
          }
        },
        { once: true }
      );
    });

    swm26ReviewUpdate();
  });
})();